import { useId } from "react";
import { Lock } from "lucide-react";

export const CardLifecycleBadge = ({ card }) => {
  const instance = useId();
  if (!card.locked_out && card.distribution_mode !== "shared_claim") return null;
  return <span data-testid={`card-lifecycle-${card.id}-${instance}`} className={`inline-flex items-center gap-1 rounded px-2 py-1 text-[10px] font-mono ${card.locked_out ? "bg-red-950/95 text-red-100 border border-red-400/60" : "bg-emerald-950/95 text-emerald-100 border border-emerald-400/50"}`}>
    {card.locked_out && <Lock className="h-3 w-3 shrink-0" />}{card.locked_out ? "LOCKED OUT" : "DIGITAL · OPEN EDITION"}
  </span>;
};